import { PlaceReservationConfirmation } from 'gleblu-socket-api';

enum ReservationAcceptState {
  Accepted,
}

export default ReservationAcceptState;

export const successMap = new Map([[PlaceReservationConfirmation.successful, ReservationAcceptState.Accepted]]);
